import Link from "next/link";
import { Phone } from "lucide-react";

import { Button } from "@/components/ui/button";

type HeaderPhoneButtonProps = {
  href?: string;
  label?: string;
  size?: "default" | "sm" | "lg" | "icon";
};

export default function HeaderPhoneButton({
  href = "tel:+36202972717",
  label = "(+36) 20 297 2717",
  size = "lg",
}: HeaderPhoneButtonProps) {
  return (
    <Button
      size={size}
      variant="outline"
      className="gap-2 border-primary-foreground/30 bg-primary-foreground/10 text-primary-foreground hover:bg-hill-secondary hover:text-primary-foreground"
      asChild
    >
      <Link href={href}>
        <Phone className="h-5 w-5" />
        {label}
      </Link>
    </Button>
  );
}
